import * as React from 'react';
import { FC, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import stylesheet, { blue } from 'src/constants/stylesheet';
import { useApi } from 'src/@context/Api';
import { Language } from 'src/utils/Languages';
import { NavLink } from 'react-router-dom';
import * as classNames from 'classnames';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            backgroundColor: 'white',
        },
        menu: {
            borderTop: `1px solid ${blue}`,
            borderBottom: `1px solid ${blue}`,
        },
        menuInner: {
            maxWidth: 870,
            margin: '0 auto',
            textAlign: 'center',
        },
        menuLink: {
            ...stylesheet.Menu,
            display: 'inline-block',
            textTransform: 'uppercase',
            padding: '5px 7px 3px 7px',
        },
        menuLinkButton: {
            backgroundColor: 'transparent',
            border: 0,
            '&:focus':{
                outline: 'none'
            }
        },
        menuLinkActive: {
            color: 'white',
            backgroundColor: blue
        },
        submenuContainer: {
            borderBottom: `1px solid ${blue}`,
        },
        submenuNav: {
            maxWidth: 870,
            margin: '0 auto',
            textAlign: 'center',
        }
    }));

export type MenuProps = {};
type Props = MenuProps;

const Menu: FC<Props> = () => {
    const cls = useStyles();
    const { app } = useApi();
    const [submenu, setSubmenu] = useState<PagesDto>();

    return (
        <div className={cls.root}>
            <div className={cls.menu}>
                <nav className={cls.menuInner}>
                    {app && app.Menus.map(menu => {
                        switch (menu.type) {
                            case "Pages":
                                const s = menu as PagesDto;
                                return (
                                    <button
                                        key={`menu-${s.UID}`}
                                        className={
                                            classNames(
                                                cls.menuLink,
                                                cls.menuLinkButton,
                                                submenu && submenu.UID === s.UID && cls.menuLinkActive)
                                        }
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onClick={() => setSubmenu(s)}
                                    >
                                        {menu.Title}
                                    </button>
                                );
                            default:
                                return (
                                    <NavLink
                                        key={`menu-${menu.UID}`}
                                        to={`/${Language}/${menu.UID}`}
                                        className={cls.menuLink}
                                        activeClassName={cls.menuLinkActive}
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onClick={() => setSubmenu(undefined)}
                                    >
                                        {menu.Title}
                                    </NavLink>
                                );
                        }
                    })}
                </nav>
            </div>
            {submenu &&
                <div className={cls.submenuContainer}>
                <nav className={cls.submenuNav}>
                    {submenu.Children.map(c =>
                        <NavLink
                            key={`menu-${c.UID}`}
                            to={`/${Language}/${submenu.UID}/${c.UID}`}
                            className={cls.menuLink}
                            activeClassName={cls.menuLinkActive}
                        >
                            {c.Title}
                        </NavLink>
                    )
                    }
                </nav>
                </div>
            }
        </div>
    );
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Components/Menu.tsx